import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useSWR from 'swr'
import { PricePlanCountInterface } from '../types/price-plan-interface'
import { PricePlanId } from '@systemeio/types'

export function usePricePlansCount(shouldFetch?: boolean, pricePlanId?: PricePlanId) {
  const { fetcher } = useFetch<RequestMethodsEnum.get, PricePlanCountInterface>({
    method: RequestMethodsEnum.get,
  })

  return useSWR(() => {
    if (shouldFetch && pricePlanId) {
      return `${DIGITAL_PRODUCT_API}/count/by-price-plan/${pricePlanId}`
    }
    return null
  }, fetcher)
}
